// Toast.jsx — transient confirmation. Every mutation in this app is invisible
// once it has happened (a revoked session leaves no trace on screen), so each
// one says what it did.

import React from 'react';

const ToastCtx = React.createContext(() => {});

export function ToastProvider({ children }) {
  const [items, setItems] = React.useState([]);

  const push = React.useCallback((text, tone = '') => {
    const id = Math.random().toString(36).slice(2);
    setItems((xs) => [...xs, { id, text, tone }]);
    setTimeout(() => setItems((xs) => xs.filter((x) => x.id !== id)), 4200);
  }, []);

  const value = React.useMemo(() => Object.assign(push, {
    ok: (t) => push(t, 'ok'),
    error: (t) => push(t, 'err'),
    warn: (t) => push(t, 'warn'),
  }), [push]);

  return (
    <ToastCtx.Provider value={value}>
      {children}
      <div className="toasts" role="status" aria-live="polite">
        {items.map((t) => (
          <div key={t.id} className={`toast ${t.tone}`}>{t.text}</div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() { return React.useContext(ToastCtx); }
